export const FETCH_FUNGI_REQUEST = 'FETCH_FUNGI_REQUEST';
export const FETCH_FUNGI_SUCCESS = 'FETCH_FUNGI_SUCCESS';
export const FETCH_FUNGI_FAILURE = 'FETCH_FUNGI_FAILURE';

export const FETCH_SPECIE_REQUEST = 'FETCH_SPECIES_REQUEST';
export const FETCH_SPECIE_SUCCESS = 'FETCH_SPECIES_SUCCESS';
export const FETCH_SPECIE_FAILURE = 'FETCH_SPECIES_FAILURE';

export const FUNGI_LIST_REQUEST = 'FUNGI_LIST_REQUEST';
export const FUNGI_LIST_SUCCESS = 'FUNGI_LIST_SUCCESS';
export const FUNGI_LIST_FAILURE = 'FUNGI_LIST_FAILURE';

export const FETCH_GBIF_REQUEST = 'FETCH_GBIF_REQUEST';
export const FETCH_GBIF_SUCCESS = 'FETCH_GBIF_SUCCESS';
export const FETCH_GBIF_FAILURE = 'FETCH_GBIF_FAILURE';
